export default {
    getFirstLevelName(state) {
        return state.firstLevelName;
    },
};
